// Registry of in-flight direct-load 3D uploads. A dropped model renders from a
// temp `local:` key while its real CDN upload runs in the background; runs wait on
// these (see `awaitPendingDirectLoadUploads`) so a run payload never ships an
// unfetchable `local:` key to the server.
const pendingUploads = new Map<string, { promise: Promise<void>; resolve: () => void }>();

export function beginDirectLoadUpload(localKey: string): void {
  if (pendingUploads.has(localKey)) return;
  let resolve!: () => void;
  const promise = new Promise<void>((res) => {
    resolve = res;
  });
  pendingUploads.set(localKey, { promise, resolve });
}

// Marks an upload as no longer in flight — called once it finalizes (temp key
// swapped for the CDN url) or is cancelled/failed.
export function endDirectLoadUpload(localKey: string): void {
  const pending = pendingUploads.get(localKey);
  if (!pending) return;
  pending.resolve();
  pendingUploads.delete(localKey);
}

// Resolves once every upload in flight at call time has finalized (or failed).
// Uploads started after this call are not awaited.
export async function awaitPendingDirectLoadUploads(): Promise<void> {
  await Promise.all([...pendingUploads.values()].map((pending) => pending.promise));
}
